import { useState, useEffect, useMemo, useRef } from "react";
import { parsePhoneObjToString } from "../utils/utils";
import { Modal, TextField, Button } from "@material-ui/core";
import { shouldBeLocked } from "../utils/Roles";

const PhoneInput = ({
  setPhoneNumber,
  phoneString = "",
  pisId,
  personId,
  modalClass,
  textFieldClass,
  inputClass,
  paperClass,
  title,
  propertyName,
  style,
  disabled,
  userRoles,
  ...props
}) => {
  const memoizedLocked = useMemo(
    () => shouldBeLocked(disabled, props?.canEdit, userRoles),
    [disabled, props?.canEdit, userRoles]
  );

  const [phoneModal, setPhoneModal] = useState(false);
  const phoneInputRef = useRef(null);
  const focusGuardRef = useRef(false);
  const [parsedPhone, setParsedPhone] = useState({
    areaCode: "",
    prefix: "",
    lineCode: "",
    ext: "",
  });
  useEffect(() => {
    if (phoneString) {
      let ext = phoneString.split("#")[1] || "";
      let phoneNoExtString = phoneString.split("#")[0] || "";
      let phoneParts = phoneNoExtString.split("-");
      setParsedPhone({
        areaCode: phoneParts[0],
        prefix: phoneParts[1],
        lineCode: phoneParts[2],
        ext: ext,
      });
    }
  }, [phoneString]);

  const handleLocalPhoneChange = e => {
    let name = e.target.name;
    let value = e.target.value;
    setParsedPhone(prevState => {
      return { ...prevState, [name]: value };
    });
  };

  const sendPhoneUpdate = e => {
    e.preventDefault();
    focusGuardRef.current = true;
    if (phoneInputRef.current) {
      phoneInputRef.current.blur();
    }
    setPhoneModal(false);
    window.setTimeout(() => {
      focusGuardRef.current = false;
    }, 0);
    let phoneNumber = parsePhoneObjToString(parsedPhone);
    setPhoneNumber(phoneNumber, propertyName);
  };

  const cancelPhoneChange = e => {
    e.preventDefault();
    focusGuardRef.current = true;
    if (phoneInputRef.current) {
      phoneInputRef.current.blur();
    }
    setPhoneModal(false);
    window.setTimeout(() => {
      focusGuardRef.current = false;
    }, 0);
    if (phoneString) {
      let ext = phoneString.split("#")[1] || "";
      let phoneNoExtString = phoneString.split("#")[0] || "";
      let phoneParts = phoneNoExtString.split("-");
      setParsedPhone({
        areaCode: phoneParts[0],
        prefix: phoneParts[1],
        lineCode: phoneParts[2],
        ext: ext,
      });
    }
  };

  const textFieldInputDataCy =
    propertyName === "phone"
      ? "primary-phone-textfield-input-" + personId
      : `${propertyName}-phone-textfield-input-${personId}`;

  return (
    <>
      <TextField
        data-cy={`${propertyName}-phone-textfield-${personId}`}
        inputProps={{ "data-cy": textFieldInputDataCy }}
        InputLabelProps={{ shrink: true }}
        inputRef={phoneInputRef}
        id={title + personId}
        label={title}
        // value={person?.personalAttribute?.phone || ""}
        value={parsePhoneObjToString(parsedPhone)}
        onClick={() => {
          if (!focusGuardRef.current) {
            setPhoneModal(true);
          }
        }}
        onFocus={() => {
          if (!focusGuardRef.current) {
            setPhoneModal(true);
          }
        }}
        className={textFieldClass}
        style={style}
        disabled={memoizedLocked}
      />
      <Modal
        // disableEnforceFocus
        open={phoneModal}
        // onClose={() => setPhoneModal(false)}
        className={modalClass}
      >
        <form className={paperClass} onSubmit={sendPhoneUpdate}>
          <TextField
            data-cy={`${propertyName}-phone-area-code-${pisId}`}
            inputProps={{
              "data-cy": `${propertyName}-phone-area-code-input-${pisId}`,
            }}
            id={"area-code-" + pisId}
            label="Area Code (XXX)"
            value={parsedPhone?.areaCode || ""}
            name="areaCode"
            onChange={handleLocalPhoneChange}
            // onChange={(e) => console.log(e.target.value)}
            className={inputClass}
            InputLabelProps={{ shrink: true }}
            disabled={memoizedLocked}
          />
          <TextField
            data-cy={`${propertyName}-phone-prefix-${pisId}`}
            inputProps={{
              "data-cy": `${propertyName}-phone-prefix-input-${pisId}`,
            }}
            id={"first-three-phone-" + pisId}
            label="XXX"
            value={parsedPhone?.prefix || ""}
            name="prefix"
            onChange={handleLocalPhoneChange}
            className={inputClass}
            InputLabelProps={{ shrink: true }}
            disabled={memoizedLocked}
          />
          <TextField
            data-cy={`${propertyName}-phone-line-code-${pisId}`}
            inputProps={{
              "data-cy": `${propertyName}-phone-line-code-input-${pisId}`,
            }}
            id={"second-four-phone-" + pisId}
            label="XXXX"
            value={parsedPhone?.lineCode || ""}
            name="lineCode"
            onChange={handleLocalPhoneChange}
            className={inputClass}
            InputLabelProps={{ shrink: true }}
            disabled={memoizedLocked}
          />
          <TextField
            data-cy={`${propertyName}-phone-extension-${pisId}`}
            inputProps={{
              "data-cy": `${propertyName}-phone-extension-input-${pisId}`,
            }}
            id={"phone-extension-" + pisId}
            label="Ext."
            value={parsedPhone?.ext || ""}
            name="ext"
            onChange={handleLocalPhoneChange}
            className={inputClass}
            InputLabelProps={{ shrink: true }}
            disabled={memoizedLocked}
          />
          <Button
            data-cy={`${propertyName}-phone-submit-button-${pisId}`}
            disabled={memoizedLocked}
            type="submit"
          >
            Ok
          </Button>
          <Button
            data-cy={`${propertyName}-phone-cancel-button-${pisId}`}
            type="button"
            onClick={cancelPhoneChange}
          >
            Cancel
          </Button>
        </form>
      </Modal>
    </>
  );
};

export default PhoneInput;
